import { useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useSync } from './useSync';
import { toastService } from '../services/toastService';
import { fetchForms } from '../reducers/formsSlice';

export const useProjectsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { manualSync, pendingCount } = useSync();
  const { forms, status: formsStatus } = useSelector(state => state.forms);
  const isDataReady = formsStatus === 'succeeded' || (forms && forms.length > 0);

  useEffect(() => {
    dispatch(fetchForms(true));
  }, [dispatch]);

  const { completedForms, allFormsSorted } = useMemo(() => {
    if (!forms || forms.length === 0) {
      return { completedForms: [], allFormsSorted: [] };
    }
    
    const sorted = [...forms].sort((a, b) => 
      new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at)
    );

    const completed = sorted.filter(form => 
      form.submissions_exists === true || 
      form.submissions_exists === "true" || 
      form.submissions_exists === 1
    );
    
    return { completedForms: completed, allFormsSorted: sorted };
  }, [forms]);

  const handleFillForm = (surveyId) => navigate(`/forms/fill/${surveyId}`);

  const handleSyncNow = () => {
    if (pendingCount > 0) {
      manualSync({ showToast: true }).catch(() => {});
    } else {
      toastService.info('Everything is up to date.');
    }
  };

  return {
    navigate,
    pendingCount,
    forms,
    formsStatus,
    isDataReady,
    completedForms,
    allFormsSorted,
    handleFillForm,
    handleSyncNow
  };
};